import Model, { ID, IsoDateTime, JsonObject } from 'src/models/Model'

export default class DataMigrationSegment extends Model {
  static name = 'DataMigrationSegment'

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Data]

  static paginate = true

  static define () {
    this.fields = {
      id: {
        type: ID,
        output: true
      },
      state: {
        type: String,
        output: true
      },
      props: {
        type: JsonObject,
        output: true
      },
      description: {
        type: String,
        output: true
      },
      startedAt: {
        type: IsoDateTime,
        output: true
      },
      completedAt: {
        type: IsoDateTime,
        output: true
      },
      erroredAt: {
        type: IsoDateTime,
        output: true
      },
      errorMessage: {
        type: String,
        output: true
      }
    }
  }
}
